import React, { Component } from 'react';
import {Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { axi} from '../constants'
import {NavbarBrand, CenterTitle} from './header'
import {setToken, setUserPhone, setUserRole, setUserSettings, setUserProfile} from '../storage'

class Login extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit  = this.handleSubmit.bind(this)
    this.state = {username:'', password:'', submitting:false}
  }

  handleChange(e) {
    e.preventDefault();

    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({
      [e.target.name]: value
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({submitting:true})
    axi({
      url: '/login/',
      method:'post',
      data: {
        username: this.state.username, password: this.state.password
      }
    }).then((response)=>{
      if(response.status === 200) {
        const token = response.data.token
        const phone = response.data.phone
        const role = response.data.role
        const settings = response.data.settings
        setToken(token)
        setUserPhone(phone)
        setUserRole(role)
        setUserSettings(settings)
        setUserProfile(response.data.company_profile)
        window.location.href = '/';
      }
    }).catch((err)=>{
      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }
      this.setState({submitting:false})
    })
  }
  render() {
    if(this.props.auth.authenticated ) {
      window.location.href = '/dashboard';
    }
    let submitButton = <button className="btn btn-primary btn-block" >Submit</button>

    if(this.state.submitting) {
      submitButton = <button className="btn btn-primary btn-block" disabled>Submit..</button>
    }

    let error_response_data = this.state.error_response_data
    let errors, non_field_errors
    let login_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      if(typeof errors !== "undefined") {
        if(typeof errors.login !== "undefined" && errors.login.length > 0) {
          login_error = errors.login[0]
        }
      }
      non_field_errors = error_response_data.non_field_errors
      if(typeof non_field_errors !== "undefined") {
        login_error = non_field_errors[0]
      }

    }

    return (
      <div>

        <section>
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <div className="" >
                        <CenterTitle />
                        <h1 className="text-center">Login</h1>
                        <form onSubmit={this.handleSubmit}>
                          <div className="form-group">
                            <label htmlFor="username">Phone</label>
                            <div className="input-group">
                              <div className="input-group-addon">+91</div>
                              <input type="text" name="username" className="form-control " onChange={this.handleChange} value={this.state.username} required/>
                            </div>

                          </div>

                          <div className="form-group">
                          <label htmlFor="password">Password</label>
                          <Link className="pull-right" to="/forgot_password">Forgot Password ?</Link>
                            <input type="password" name="password" className="form-control" onChange={this.handleChange} value={this.state.password} autoComplete="off" required />
                          </div>
                          <p className="text-danger">{login_error}</p>
                          <div className="form-group">
                            {submitButton}
                          </div>

                        </form>
                        <p>Not registered ? <Link to="/signup" className="">Create Account</Link></p>
                  </div>
                </div>
              </div>
          </div>

        </section>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.authReducer
  }
}

export default connect(mapStateToProps)(withRouter(Login))



// WEBPACK FOOTER //
// ./src/components/login.js